import React, { useEffect, useRef, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const EVERY = 300;

// Soft refresh of the cards every 5 minutes (countdown) or on demand; the page itself never reloads.
export function TagRefreshTimer({ onRefresh, busy }) {
  const [left, setLeft] = useState(EVERY);
  const due = useRef(false);
  const run = () => { setLeft(EVERY); due.current = false; onRefresh(); };
  const runRef = useRef(run);
  runRef.current = run;
  useEffect(() => {
    const t = setInterval(() => setLeft((s) => {
      if (s > 1) return s - 1;
      if (document.hidden) { due.current = true; return 0; }
      setTimeout(() => runRef.current(), 0);
      return EVERY;
    }), 1000);
    const vis = () => { if (!document.hidden && due.current) runRef.current(); };
    document.addEventListener('visibilitychange', vis);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', vis); };
  }, []);
  const mm = Math.floor(left / 60); const ss = String(left % 60).padStart(2, '0');
  return (
    <button type="button" onClick={run} disabled={busy} title="Refresh the cards now (auto-refresh every 5 minutes)"
      className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-border bg-background px-2.5 text-sm font-medium text-foreground hover:bg-secondary disabled:opacity-60" data-testid="tagws-refresh-button">
      <RefreshCw size={14} className={busy ? 'animate-spin' : ''} />
      <span className="font-mono text-xs tabular-nums text-muted-foreground" data-testid="tagws-refresh-countdown">{busy ? 'Refreshing…' : `${mm}:${ss}`}</span>
    </button>
  );
}
